import {Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import {ModalComponent} from '../modal/modal.component';

@Component({
  selector: 'app-image-carousel',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, ModalComponent],
  templateUrl: './image-carousel.component.html',
  styleUrls: ['./image-carousel.component.scss']
})
export class ImageCarouselComponent implements OnInit, OnDestroy {
  @Input() images: string[] = [];
  @Input() interval = 0; // autoplay disabled by default in admin

  index: number = 0;
  fullscreenOpen: boolean = false;
  private timer?: any;

  ngOnInit() {
    this.play();
  }

  ngOnDestroy() {
    this.pause();
  }

  play() {
    this.pause();
    if (this.interval > 0 && this.images.length > 1) {
      this.timer = setInterval(() => this.next(), this.interval);
    }
  }

  pause() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = undefined;
    }
  }

  next() {
    this.index = (this.index + 1) % (this.images.length || 1);
  }

  prev() {
    this.index = (this.index - 1 + (this.images.length || 1)) % (this.images.length || 1);
  }

  goTo(i: number) {
    if (i >= 0 && i < this.images.length) {
      this.index = i;
    }
  }

  openFullscreen(startIndex?: number) {
    if (typeof startIndex === 'number') this.goTo(startIndex);
    this.fullscreenOpen = true;
    this.pause();
  }

  closeFullscreen() {
    this.fullscreenOpen = false;
    this.play();
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(e: KeyboardEvent) {
    if (!this.fullscreenOpen) return;
    if (e.key === 'Escape') {
      this.closeFullscreen();
    } else if (e.key === 'ArrowRight') {
      this.next();
    } else if (e.key === 'ArrowLeft') {
      this.prev();
    }
  }
}
